module.exports = __webpack_public_path__ + "img/caspop-no-bg.09fb9c15.png";